<div class="container">
    <div class="header">
        <h5 class="title" data-cy="ops-settings-accounts-permissions-modal-header">
            {{ 'account-setting.ops-user-edit' | translate }}
        </h5>

        <div class="buttons-container">
            <div class="cancel button" (click)="cancelClick()">
                {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
            </div>

            <div
                class="create button"
                data-cy="ops-settings-accounts-permissions-save-button"
                [class.disabled]="!isModified"
                (click)="isModified && createButtonClick()">
                {{ 'account-setting.edit.permissions.save' | translate }}
            </div>
        </div>
    </div>
    <div class="container">
        <div class="table-header">
            <div class="category-info">
                {{
                    'account-setting.category.' + (categoryList.length === 1 ? 'one' : 'other')
                        | translate
                            : {
                                  categoryRangeLabel: categoryRangeLabel,
                                  categoryLength: categoryList.length,
                              }
                }}
            </div>
            <div class="navigation-icons">
                <mat-icon
                    svgIcon="arrow-circle-left"
                    [ngClass]="{ active: currentPage > 0 }"
                    (click)="prevPage()"></mat-icon>
                <mat-icon
                    svgIcon="arrow-circle-right"
                    [ngClass]="{
                        active: (currentPage + 1) * pageSize < headerCategories.length,
                    }"
                    (click)="nextPage()"></mat-icon>
            </div>
        </div>

        <div class="permissions-table">
            <table>
                <thead>
                    <tr>
                        <th>{{ 'account-setting.account' | translate }}</th>
                        <th *ngFor="let header of pagedHeaderCategories">
                            <div *ngIf="header" class="cell-content">
                                {{ header.display | slice: 0 : CATEGORY_MAX_LEN
                                }}{{ header.display.length > CATEGORY_MAX_LEN ? ELLIPSIS : '' }}
                                <mat-icon svgIcon="dp-more-vert" (click)="toggleMenu(header.key)"></mat-icon>
                                <div *ngIf="showHeaderMenu[header.key]" style="position: relative; align-self: end">
                                    <div class="more-options-container">
                                        <div class="placeholder-text" (click)="setEditChannelsForCategory(header.key)">
                                            {{ 'account-setting.edit.channel.users.check' | translate }}
                                        </div>
                                        <div class="placeholder-text" (click)="setControlMimicsForCategory(header.key)">
                                            {{ 'account-setting.control.mimics.users.check' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of userList; let i = index">
                        <td>
                            <div class="cell-content">
                                <span data-cy="ops-settings-accounts-permissions-account-name">{{ user.name }}</span>
                                <mat-icon
                                    svgIcon="dp-more-vert"
                                    (click)="toggleMenu(i); $event.stopPropagation()"></mat-icon>
                                <div *ngIf="showRowMenu[i]" class="more-options-container">
                                    <div
                                        class="placeholder-text"
                                        (click)="setEditChannelsForUser(i)"
                                        [ngClass]="{ disabled: isAdmin(user) }">
                                        {{ 'account-setting.edit.channel.categories.check' | translate }}
                                    </div>
                                    <div
                                        class="placeholder-text"
                                        (click)="setControlMimicsForUser(i)"
                                        [ngClass]="{ disabled: isAdmin(user) }">
                                        {{ 'account-setting.control.mimics.categories.check' | translate }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td *ngFor="let header of pagedHeaderCategories">
                            <div *ngIf="header" class="cell-content">
                                <div>
                                    <div class="cell-item">
                                        <mat-checkbox
                                            data-cy="ops-settings-accounts-permissions-edit-channels-checkbox"
                                            [(ngModel)]="user.permissions[header.key].editChannels"
                                            (change)="markAsModified()"
                                            [disabled]="isAdmin(user)">
                                            {{ 'account-settings.cell.edit-channels' | translate }}
                                        </mat-checkbox>
                                    </div>
                                    <div class="cell-item">
                                        <mat-checkbox
                                            data-cy="ops-settings-accounts-permissions-control-mimics-checkbox"
                                            [(ngModel)]="user.permissions[header.key].controlMimic"
                                            (change)="markAsModified()"
                                            [disabled]="isAdmin(user)">
                                            {{ 'account-settings.cell.control-mimic' | translate }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
